import getCollections from './getCollections'
import getItems from './getItems'

export default {
  ...getCollections,
  ...getItems
}
